import { IsNotEmpty, IsOptional, IsString } from 'class-validator';

import BaseIvrNode, { EMPTY_ERROR_ID_MESSAGE } from 'src/models/Ivrs/Nodes/baseIvrNode';

export default class EmailAuthCode extends BaseIvrNode {
  @IsString()
  @IsNotEmpty({ message: 'Please select an answer' })
  answerId: string;

  @IsString()
  @IsNotEmpty({ message: 'Please a language' })
  answerLanguage: string;

  @IsString()
  @IsNotEmpty()
  emailToAddress: string;

  @IsString()
  @IsNotEmpty({ message: 'Please select an email address' })
  emailFromAddress: string;

  @IsString()
  @IsOptional()
  nextId?: string;

  @IsString()
  @IsNotEmpty({ message: EMPTY_ERROR_ID_MESSAGE })
  errorNodeId: string;
}
